<div class="user-card" *ngIf="currentUser$ | async as currentUser">
  <button
    appHaptics
    class="select-account-button"
    (click)="expandUserSwitcher = !expandUserSwitcher"
    [attr.disabled]="
      !tenantFeatures.connectedAccounts || isMultiUserModeActive ? true : null
    "
    [disableHaptics]="
      !tenantFeatures.connectedAccounts || isMultiUserModeActive
    "
  >
    <div class="user-info">
      <div class="user-name">
        {{ currentUser.firstName }} {{ currentUser.lastName }}
      </div>
      <!-- <div class="user-info-row">{{ currentUser.email }}</div> -->
      <div class="user-info-row">{{ tenantName }}</div>
    </div>
    <ion-icon
      *ngIf="tenantFeatures.connectedAccounts && !isMultiUserModeActive"
      name="chevron-down"
      class="select-account-arrow"
      [ngClass]="{ 'select-account-arrow--opened': expandUserSwitcher }"
    />
  </button>

  <div
    *ngIf="tenantFeatures.connectedAccounts && !isMultiUserModeActive"
    class="select-account-menu"
    [ngClass]="{ 'select-account-menu--opened': expandUserSwitcher }"
    [@submenuInOut]="expandUserSwitcher ? 'in' : 'out'"
  >
    <div class="select-account-group" *ngFor="let group of myConnectedAccounts">
      <div class="select-account-group-title">
        <div class="select-account-group-title-text">
          {{ group.email }}
        </div>
        <ion-icon
          *ngIf="!isGroupActive(group, currentUser)"
          (click)="removeAccount(group, $event)"
          name="close-circle"
          class="remove-account-button"
          color="danger"
          title="Unlink"
        />
      </div>

      <button
        *ngFor="let account of group.accounts"
        appHaptics
        class="select-account-group-item"
        [ngClass]="{
          'select-account-group-item--active': account._id === currentUser._id
        }"
        (click)="changeAccount(account._id, account.tenant._id)"
        [attr.disabled]="account._id === currentUser._id ? true : null"
        [disableHaptics]="account._id === currentUser._id"
      >
        <ion-icon
          [name]="
            account._id === currentUser._id
              ? 'checkmark-circle'
              : 'ellipse-outline'
          "
        />
        <div class="select-account-group-item-title">
          {{ account.tenant.name }}
        </div>
      </button>
    </div>

    <div class="select-account-group">
      <button class="add-account-button" (click)="addAccount()">
        Add Account
      </button>
    </div>

    <!-- <div class="balances">
      <div class="balance-row">
        Last 30 Days
        <span class="redeem-balance">
          {{ (receivedInPeriod$ | async)?.points }} pts
        </span>
      </div>
      <div class="balance-row">
        Team Average
        <span class="redeem-balance">
          {{
            (teamAverageInPeriod$ | async)?.teamAveragePoints.toFixed(0)
          }}
          pts
        </span>
      </div>
    </div> -->
  </div>
</div>
